import {AgentMeterIdsFormGroup, MeterForAgent} from '../select-meters-for-agent.model';
import {FormControl, FormGroup} from '@angular/forms';
import {SelectableItem} from '@brunata-angular/ui';
import {DateTime} from 'luxon';
import {Translation} from '@brunata-angular/util';

export type FilterMetersFormGroup = FormGroup<{
    selectedGroup1: FormControl<SelectableItem[]>;
    selectedGroup2: FormControl<SelectableItem[]>;
    usageAndUnit: FormControl<SelectableItem[]>;
    meterModel: FormControl<SelectableItem[]>;
    meterNo: FormControl<string>;
    meterId: FormControl<string>;
    placement: FormControl<string>;
    address: FormControl<string>;
    propertyNo: FormControl<string>;
    branchNo: FormControl<string>;
    locationNo: FormControl<string>;
    consumerName: FormControl<string>;
    mountingDate: FormControl<DateTime | null>;
    dismountedDate: FormControl<DateTime | null>;
}>;

export type SelectedColumnsFormGroup = FormGroup<{
    [K in keyof FilterMetersFormGroup['controls']]: FormControl<boolean>;
}>;

export type SelectMetersTableFormGroup = FormGroup<{
    selectedColumnsFormGroup: SelectedColumnsFormGroup;
    filterFormGroup: FilterMetersFormGroup;
}>;

export type AgentMeterTableFormGroup = {
    meterIdGroupsFormGroup: AgentMeterIdsFormGroup;
    visibleColumnsFormGroup: SelectedColumnsFormGroup;
    filterFormGroup: FilterMetersFormGroup;
};

export type MetersForAgentTableData = {
    headers: SelectMetersTableHeader[];
    meters: AgentTableMeters;
    compareGroups: boolean;
    page: number;
    pageSize: number;
};

export type SelectableAgentMeter = MeterForAgent & {
    selectedGroup1: boolean;
    selectedGroup2: boolean;
    isReplacement: boolean;
};

export type AgentTableMeters = {
    all: SelectableAgentMeter[];
    filtered: SelectableAgentMeter[];
    paginated: SelectableAgentMeter[];
    allInGroup1Checked: boolean;
    allInGroup2Checked: boolean;
};

type TableHeaderInput = {
    formControlKey: keyof AgentMeterIdsFormGroup['controls'];
    valueKey: keyof AgentTableMeters;
};

type SelectMetersTableHeader = {
    key: keyof SelectedColumnsFormGroup['controls'];
    inputType: 'text' | 'date' | 'multiSelect';
    label: Translation;
    input?: TableHeaderInput;
    canHide?: boolean;
};

export const headers: SelectMetersTableHeader[] = [
    {
        key: 'selectedGroup1',
        inputType: 'multiSelect',
        label: {
            key: 'utilities_group1',
        },
        input: {
            formControlKey: 'idsInGroup1',
            valueKey: 'allInGroup1Checked',
        },
    },
    {
        key: 'selectedGroup2',
        inputType: 'multiSelect',
        label: {
            key: 'utilities_group2',
        },
        input: {
            formControlKey: 'idsInGroup2',
            valueKey: 'allInGroup2Checked',
        },
    },
    {
        key: 'meterNo',
        inputType: 'text',
        label: {
            key: 'properties_meterNo',
            module: 'systems',
        },
    },
    {
        key: 'meterModel',
        inputType: 'multiSelect',
        label: {
            key: 'properties_meterModel',
            module: 'systems',
        },
        canHide: true,
    },
    {
        key: 'placement',
        inputType: 'text',
        label: {
            key: 'properties_placement',
            module: 'systems',
        },
        canHide: true,
    },
    {
        key: 'usageAndUnit',
        inputType: 'multiSelect',
        label: {
            key: 'consumption-agents_meter-usage-and-unit',
        },
        canHide: true,
    },
    {
        key: 'mountingDate',
        inputType: 'date',
        label: {
            key: 'properties_mountingDate',
            module: 'common',
        },
        canHide: true,
    },
    {
        key: 'dismountedDate',
        inputType: 'date',
        label: {
            key: 'utilities_dismount-date',
        },
        canHide: true,
    },
    {
        key: 'address',
        inputType: 'text',
        label: {
            key: 'properties_address',
            module: 'systems',
        },
        canHide: true,
    },
    {
        key: 'propertyNo',
        inputType: 'text',
        label: {
            key: 'common_SECONDSECTORNO',
            module: 'common',
        },
        canHide: true,
    },
    {
        key: 'branchNo',
        inputType: 'text',
        label: {
            key: 'common_FIRSTSECTORNO',
            module: 'common',
        },
        canHide: true,
    },
    {
        key: 'locationNo',
        inputType: 'text',
        label: {
            key: 'common_LOCATIONNO',
            module: 'common',
        },
        canHide: true,
    },
    {
        key: 'consumerName',
        inputType: 'text',
        label: {
            key: 'common_current_resident',
            module: 'common',
        },
        canHide: true,
    },
];
